<div class="chart-title">{{chartTitle}}</div>
<div class="chart-container">
  <canvas baseChart
    [data]="chartData"
    [options]="chartOptions"
    [type]="'bar'"
    (chartClick)="onChartClick($event)">
  </canvas>
</div>
